import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';

import { InlineAddPanelComponent } from '../inline-add-panel/inline-add-panel.component';
import { SelectInstantBaseComponent } from './selectInstant-base';

@Component({
  selector: 'app-select-base',
  template: '',
  providers: []
})
export abstract class SelectInstantBaseNewComponent
  extends SelectInstantBaseComponent
  implements AfterContentInit
{
  @ViewChild('inlineAddPanel') inlineAddPanel!: InlineAddPanelComponent;
  @Input() showAddNewButton: boolean = true;
  @Input() ocrSuggested: any[] | null = null;
  showInlineAddPanel = false;
  storedInstantData: string = '';
  protected pendingInstantData: string = ''; // Separate variable to preserve instant data for Add New
  private focusTrapHandler: ((event: FocusEvent) => void) | null = null;
  private pendingSearchPromise: Promise<any[]> | null = null; // Track pending search to wait for completion

  constructor(http: _HttpClient, cdr: ChangeDetectorRef, router: Router) {
    super(http, cdr, router);
    this.valueField = '';
  }

  ngAfterContentInit(): void {
    this.preventArrowKeyDropdownOpen();
  }

  override valueChanged(val: any, isInstantData: boolean = false): void {
    // If the search keyword is not empty, and the search result is not yet loaded,
    // avoid selecting the first item from the dropdown list on Enter key pressed
    // Also prevent selection if a search is currently in progress
    if (
      this.searchForm.controls.keyword.value &&
      (this.searchForm.controls.keyword.value !==
        this.searchForm.controls.resultKeyword.value ||
        this.loading)
    ) {
      return;
    }

    // Remove focus trap when value is selected
    this.removeFocusTrap();

    this.value = val;
    const queryParam = this.queryParam();

    if (isInstantData) {
      var instantData = this.instantData;
      this.clearSelection().then(() => {
        if (this.jump() != undefined) {
          if (instantData) {
            setTimeout(() => {
              this.router.navigate([this.jump()], {
                queryParams: {
                  [queryParam as string]: instantData,
                  autoPopulate: 1
                }
              });
            }, 50);
          } else {
            setTimeout(() => {
              this.router.navigate([this.jump()], {
                queryParams: {
                  autoPopulate: 1
                }
              });
            }, 50);
          }
        }
      });
    } else if (this.valueField) {
      this.selected = this.list.find(x => x[this.valueField] === val);
    } else {
      this.selected = val;
    }
    this.onChange(val);
    this.selectedChange.emit(this.selected);
  }
  // clear the selection if it is add new

  //  // Keyboard behavior: Enter selects focused item; if none focused, selects first real item
  //   override handleKeyDown(event: KeyboardEvent): void {
  //     // Let base handle generic behaviors first
  //     super.handleKeyDown(event);
  //     if (event.key !== 'Enter') return;

  //     // Prevent default enter submitting parent forms
  //     event.preventDefault();
  //     event.stopPropagation();

  //     // Build visible options: skip the Add New pseudo option
  //     const options = (this.list || []).filter(x => x != null);
  //     const hasItems = options.length > 0;
  //     const keyword = (this.getCurrentSearchValue() || '').trim();

  //     // Check if the focused option is the "Add New" button
  //     const focusedOptionIndex = this.getFocusedOption();

  //     if (focusedOptionIndex === -1) {
  //       // Focus is on "Add New" button - only show inline panel if showInlineAddPanel is true
  //       if (this.showAddNewButton) {
  //         this.onAddNewClick();
  //       } else {
  //         // Close dropdown if inline panel is disabled
  //         try { this.selector?.setOpenState(false); } catch {}
  //       }
  //       return;
  //     }

  //     if (hasItems) {
  //       // Check if there's a focused item in the dropdown
  //       let selectedItem;

  //       if (focusedOptionIndex >= 0 && focusedOptionIndex < options.length) {
  //         // Use the focused item
  //         selectedItem = options[focusedOptionIndex];
  //       } else {
  //         // Fallback to first item if no focused item
  //         selectedItem = options[0];
  //       }

  //       const val = this.getValue(selectedItem);
  //       this.valueChanged(val);
  //       // Close dropdown
  //       try { this.selector?.setOpenState(false); } catch {}
  //     } else {
  //       // No items; if keyword present, treat as Add New - only show inline panel if showInlineAddPanel is true
  //       if (keyword && this.showInlineAddPanel) {
  //         this.onAddNewClick();
  //       } else {
  //         try { this.selector?.setOpenState(false); } catch {}
  //       }
  //     }
  //   }
  preventEnterToChooseItem = false;
  onDropdownOpenChange(open: boolean): void {
    if (open) {
      // After dropdown opens, ensure first item is activated/focused, then log
      this.ensureFirstItemActivatedAndFocused();
      this.preventEnterToChooseItem = true;
      // Set up focus management when dropdown opens
      this.setupFocusTrap();
      this.ensureDropdownInputFocused();
    } else {
      this.preventEnterToChooseItem = false;
      // Remove focus trap when dropdown closes
      this.removeFocusTrap();
      // When dropdown closes, capture the current search input value only if we don't already have stored data
      if (!this.storedInstantData) {
        this.captureCurrentSearchValue();
      }
    }
    this.openChange.emit(open);
  }

  // Ensure indices align with first item (0) or -1 when empty; waits for DOM to render
  ensureFirstItemActivatedAndFocused(attempt: number = 0): void {
    try {
      const nzSelectComponent = this.selector as any;
      const hasItems = Array.isArray(this.list) && this.list.length > 0;

      const dropdowns = document.querySelectorAll('.dropdownSelect');
      const dropdown = dropdowns[dropdowns.length - 1] as
        | HTMLElement
        | undefined;
      const options = dropdown?.querySelectorAll('.ant-select-item-option');

      // If dropdown DOM not ready yet, retry a few times
      if (!dropdown || !options || options.length === 0) {
        if (attempt < 6) {
          setTimeout(
            () => this.ensureFirstItemActivatedAndFocused(attempt + 1),
            40
          );
        }
        return;
      }

      if (hasItems) {
        // Activate first data item
        if (nzSelectComponent) nzSelectComponent.activatedValue = this.list[0];
        // Highlight first real option in DOM (skip Add New when present)
        const domIndex = this.showAddNewButton && options.length > 1 ? 1 : 0;
        this.setActiveOptionByIndex(options, domIndex);
      } else {
        // No items: clear activation and clear DOM active state
        if (nzSelectComponent) nzSelectComponent.activatedValue = null;
        this.setActiveOptionByIndex(options, -1 as unknown as number);
      }
    } catch {}
  }

  /**
   * Sets the active option by index using proper event simulation
   */
  private setActiveOptionByIndex(
    options: NodeListOf<Element>,
    targetIndex: number
  ): void {
    // First, clear all active states by simulating mouse leave on all options
    options.forEach((opt, index) => {
      if (index !== targetIndex) {
        const mouseLeaveEvent = new MouseEvent('mouseleave', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        opt.dispatchEvent(mouseLeaveEvent);
      }
    });

    // Then simulate mouse enter on the target option
    if (options[targetIndex]) {
      const mouseEnterEvent = new MouseEvent('mouseenter', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      options[targetIndex].dispatchEvent(mouseEnterEvent);
    }
  }

  // Method to handle add new button click
  onAddNewClick(event?: Event): void {
    // CRITICAL: Capture the instant data synchronously at the very start, before anything else
    // This must happen before the dropdown closes or any other operations
    if (this.selector) {
      const searchInput =
        this.selector.originElement?.nativeElement?.querySelector('input');
      if (searchInput && searchInput.value) {
        const capturedValue = searchInput.value.trim();
        if (capturedValue) {
          this.pendingInstantData = capturedValue;
          this.storedInstantData = capturedValue;
        }
      }
    }

    // Fallback: Try to get from other sources if not captured from DOM
    if (!this.pendingInstantData) {
      let capturedValue = '';

      // 1. Try from search form
      capturedValue = this.getSearchFormValue();

      // 2. If not found, try from instantData
      if (!capturedValue) {
        capturedValue = this.instantData || '';
      }

      // 3. If not found, try from storedInstantData
      if (!capturedValue && this.storedInstantData) {
        capturedValue = this.storedInstantData;
      }

      if (capturedValue) {
        this.pendingInstantData = capturedValue;
        this.storedInstantData = capturedValue;
      }
    }

    // Use setTimeout to ensure we capture the value after the current execution cycle
    setTimeout(() => {
      // Call the addNew method
      this.addNew();
    }, 0);
  }

  private captureSearchValueSync(): string {
    if (this.selector) {
      const searchInput =
        this.selector.originElement.nativeElement.querySelector('input');
      if (searchInput && searchInput.value) {
        return searchInput.value.trim();
      }
    }
    return this.instantData || '';
  }

  // Method to get current search value from search form
  private getSearchFormValue(): string {
    const formValue = this.searchForm.controls.keyword.value;
    return formValue ? formValue.trim() : '';
  }

  captureCurrentSearchValue(): void {
    if (this.selector) {
      const searchInput =
        this.selector.originElement.nativeElement.querySelector('input');
      if (searchInput && searchInput.value) {
        const trimmedValue = searchInput.value.trim();
        this.storedInstantData = trimmedValue;
        // Also store in pendingInstantData for Add New
        this.pendingInstantData = trimmedValue;
      }
    }
  }

  getCurrentSearchValue(): string {
    if (this.selector) {
      const searchInput =
        this.selector.originElement.nativeElement.querySelector('input');
      if (searchInput && searchInput.value) {
        return searchInput.value.trim();
      }
    }
    return this.storedInstantData || '';
  }

  getFocusedOption(): any {
    return this.safeExecuteWithReturn(
      () => {
        // Try to get the focused index from nzSelectComponent properties
        const nzSelectComponent = this.selector as any;

        if (nzSelectComponent) {
          // Use activatedValue to find the correct index in our list
          const activatedItem = nzSelectComponent.activatedValue || {};

          // Handle OCR suggested items
          if (
            typeof activatedItem === 'string' &&
            activatedItem.includes('__ocr_suggested__')
          ) {
            return {
              type: 'ocrSuggested',
              suggestedText: activatedItem.split('__ocr_suggested__')[1]
            };
          }

          // Find this item in our list using generic comparison
          let actualIndex = this.list.findIndex(item => {
            // Try different ways to match the item
            if (item && activatedItem) {
              // Direct comparison
              if (item === activatedItem) return true;

              // If both have id property, compare by id
              if (item.id && activatedItem.id && item.id === activatedItem.id)
                return true;

              // If both have code property, compare by code
              if (item.code && activatedItem && item.code === activatedItem)
                return true;

              // If both have value property, compare by value
              if (
                item.value &&
                activatedItem.value &&
                item.value === activatedItem.value
              )
                return true;

              // If both have key property, compare by key
              if (
                item.key &&
                activatedItem.key &&
                item.key === activatedItem.key
              )
                return true;
            }
            return false;
          });

          if (actualIndex === -1) {
            // Get the exact match in the list, which the matchType is 1 (stands for Equals)
            actualIndex = this.list.findIndex(item => {
              return item.matchType === 1;
            });
          }

          if (actualIndex >= 0) {
            return actualIndex;
          }
        }

        const dropdowns = document.querySelectorAll('.dropdownSelect');
        const dropdown = dropdowns[dropdowns.length - 1] as
          | HTMLElement
          | undefined;
        if (!dropdown) {
          return -1;
        }

        const options = dropdown.querySelectorAll('.ant-select-item-option');
        if (!options) return -1;

        for (let i = 0; i < options.length; i++) {
          const option = options[i] as HTMLElement;
          if (option.classList.contains('ant-select-item-option-active')) {
            // If it's the first option (Add New), return -1 to indicate Add New is focused
            if (i === 0) {
              return -1;
            }

            // Convert to actual list index (accounting for Add New option)
            const actualIndex = i - 1;
            return actualIndex;
          }
        }
        return -1;
      },
      'getFocusedOption',
      -1
    );
  }

  private safeExecuteWithReturn<T>(
    fn: () => T,
    context: string,
    defaultValue: T
  ): T {
    try {
      return fn();
    } catch (error) {
      console.warn(`Error in ${context}:`, error);
      return defaultValue;
    }
  }

  // Method to clear stored instant data
  clearStoredInstantData(): void {
    this.storedInstantData = '';
    this.pendingInstantData = '';
  }

  // Override search method to store instant data
  override search(value: string, maxLength: number = 10): void {
    // Store the instant data before calling parent method
    if (value) {
      const trimmedValue = value.trim();
      this.storedInstantData = trimmedValue;
      // Also store in pendingInstantData for Add New
      this.pendingInstantData = trimmedValue;
    }
    super.search(value, maxLength);
  }

  // Override fetchData to track the pending search promise
  protected override fetchData(keyword: string | null): Promise<any[]> {
    // Track the promise so we can wait for it if Enter is pressed
    this.pendingSearchPromise = super.fetchData(keyword);
    return this.pendingSearchPromise;
  }

  // Handle search event from template
  onSearch(value: string): void {
    if (value) {
      const trimmedValue = value.trim();
      this.storedInstantData = trimmedValue;
      // Also store in pendingInstantData for Add New
      this.pendingInstantData = trimmedValue;
    }
    this.search(value, 250);
  }

  // Override setKeyword method to store instant data
  override setKeyword(value: string, maxLength: number = 10): void {
    // Store the instant data before calling parent method
    if (value) {
      const trimmedValue = value.trim();
      this.storedInstantData = trimmedValue;
      // Also store in pendingInstantData for Add New
      this.pendingInstantData = trimmedValue;
    }
    super.setKeyword(value, maxLength);
  }

  @HostListener('keydown', ['$event'])
  preventArrowKeyDropdownOpen(event?: KeyboardEvent) {
    setTimeout(() => {
      if (this.selector && this.selector.originElement) {
        const inputElement =
          this.selector.originElement.nativeElement.querySelector('input');
        if (inputElement) {
          // Remove existing keydown listeners and add our own
          inputElement.addEventListener(
            'keydown',
            (event: KeyboardEvent) => {
              // Only prevent dropdown from opening when closed, but allow event to bubble to table
              // When dropdown is open, don't interfere at all
              if (this.selector?.nzOpen) {
                return; // Let dropdown handle navigation
              }

              const preventOpenKeys = ['ArrowDown', 'ArrowLeft', 'ArrowRight'];
              if (preventOpenKeys.includes(event.key)) {
                // Ensure dropdown is closed, but don't prevent default or stop propagation
                // This allows the table component to handle navigation
                if (this.selector) {
                  this.selector?.setOpenState(false);
                }
                // Don't prevent default or stop propagation - let table handle navigation
              }
            },
            true
          ); // Use capture phase
        }
      }
    }, 100);
  }
  override handleClick(event: MouseEvent): void {
    this.mouseEvent = true;
    if (!this.selector?.nzOpen) this.preventEnterToChooseItem = true;
    else {
      this.preventEnterToChooseItem = false;
    }
  }
  // Keyboard behavior: Enter selects focused item; if none focused, selects first real item
  override handleKeyDown(event: KeyboardEvent): void {
    // Handle arrow keys
    if (
      ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)
    ) {
      // When dropdown is open, ArrowDown/ArrowUp should navigate within dropdown
      // ArrowLeft/ArrowRight should close dropdown and let table handle navigation
      if (this.selector?.nzOpen) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          // Let dropdown handle navigation - stop all propagation to prevent other handlers from closing dropdown
          event.stopImmediatePropagation();
          // Explicitly ensure dropdown stays open
          if (this.selector) {
            this.selector.nzOpen = true;
          }
          // Don't prevent default - let ng-zorro handle navigation within dropdown
          return;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          // Close dropdown and let table handle navigation
          this.selector.setOpenState(false);
          // Call parent handler which will allow event to bubble for table navigation
          super.handleKeyDown(event);
          return;
        }
      } else {
        // Dropdown is closed - prevent opening, but allow table to handle navigation
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          // Explicitly prevent dropdown from opening
          if (this.selector) {
            this.selector.nzOpen = false;
          }
          // Prevent default behavior (ng-zorro opening dropdown) but allow bubbling to table
          event.preventDefault();
          // Don't stop propagation - let table handle navigation
          return;
        } else {
          // For other arrow keys when closed, use parent handler
          super.handleKeyDown(event);
          return;
        }
      }
    }

    // Handle Enter key - wait for search to complete if in progress
    if (event.key === 'Enter') {
      if (this.preventEnterToChooseItem) {
        this.preventEnterToChooseItem = false;
        return;
      }
      this.handleEnterKey(event);
    }
  }

  /**
   * Handles Enter key press - performs direct search if needed, then processes Enter key
   */
  private handleEnterKey(event: KeyboardEvent): void {
    // Get the current keyword from DOM (most up-to-date, especially for barcode scanners)
    const domKeyword = (this.getCurrentSearchValue() || '').trim();
    const resultKeyword = (
      this.searchForm.controls.resultKeyword.value || ''
    ).trim();

    // If current search keyword is empty, return
    if (!domKeyword) {
      return;
    }

    // Check if we need to perform a search (keyword differs from last completed search)
    if (domKeyword !== resultKeyword) {
      // Update form control to keep it in sync (but don't trigger debounced search)
      this.searchForm.controls.keyword.setValue(domKeyword, {
        emitEvent: false
      });

      // Perform direct search (bypassing debounced stream)
      // This ensures we get fresh results before processing Enter key
      this.fetchData(domKeyword)
        .then(() => {
          // Search completed, now process Enter key with updated list
          this.processEnterKey(domKeyword);
        })
        .catch(() => {
          // Search failed, but still process Enter key (might have partial results)
          this.processEnterKey(domKeyword);
        });
    } else {
      // Search already completed for this keyword, process Enter key immediately
      this.processEnterKey(domKeyword);
    }
  }

  /**
   * Processes the Enter key after search has completed (or if no search was needed)
   */
  private processEnterKey(keyword: string): void {
    // Build visible options: skip the Add New pseudo option
    const options = (this.list || []).filter(x => x != null);

    const hasItems = options.length > 0;

    // Check if the focused option is the "Add New" button
    const focusedOptionIndex = this.getFocusedOption();

    // Handle OCR suggested items
    if (
      focusedOptionIndex &&
      focusedOptionIndex.type &&
      focusedOptionIndex.type === 'ocrSuggested'
    ) {
      const nzSelectComponent = this.selector as any;
      if (nzSelectComponent && nzSelectComponent.activatedValue) {
        const activatedItem = nzSelectComponent.activatedValue;
        if (
          typeof activatedItem === 'string' &&
          activatedItem.includes('__ocr_suggested__')
        ) {
          const suggestedText = activatedItem.split('__ocr_suggested__')[1];
          this.onOcrSuggestedClick(suggestedText);
          return;
        }
      }
    }

    if (focusedOptionIndex === -1) {
      // Focus is on "Add New" button - only show inline panel if showInlineAddPanel is true
      if (this.showAddNewButton) {
        this.onAddNewClick();
      } else {
        // Close dropdown if inline panel is disabled
        try {
          this.selector?.setOpenState(false);
        } catch {}
      }
      return;
    }

    if (hasItems) {
      // Check if there's a focused item in the dropdown
      let selectedItem;

      if (focusedOptionIndex >= 0 && focusedOptionIndex < options.length) {
        // Use the focused item
        selectedItem = options[focusedOptionIndex];
      } else {
        // Fallback to first item if no focused item
        selectedItem = options[0];
      }

      const val = this.getValue(selectedItem);
      this.valueChanged(val);
      // Close dropdown
      try {
        this.selector?.setOpenState(false);
      } catch {}
    } else {
      // No items; if keyword present, treat as Add New - only show inline panel if showInlineAddPanel is true
      if (keyword && this.showInlineAddPanel) {
        this.onAddNewClick();
      } else {
        try {
          this.selector?.setOpenState(false);
        } catch {}
      }
    }
  }
  // Method to handle OCR suggested item click
  onOcrSuggestedClick(suggestedText: string, event?: Event): void {
    // Prevent default behavior
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Set the suggested text as stored instant data
    this.storedInstantData = suggestedText;
    // Also store in pendingInstantData for Add New
    this.pendingInstantData = suggestedText;

    // Use setTimeout to ensure we capture the value after the current execution cycle
    setTimeout(() => {
      // Call the addNew method with the suggested text
      this.addNew();
    }, 0);
  }

  /**
   * Sets up focus trap to keep focus within dropdown while it's open
   */
  private setupFocusTrap(): void {
    // Remove any existing focus trap first
    this.removeFocusTrap();
    // Create focus trap handler
    this.focusTrapHandler = (event: FocusEvent) => {
      // Auto-cleanup if selector no longer exists or dropdown is closed
      if (!this.selector || !this.selector.nzOpen) {
        this.removeFocusTrap();
        return;
      }

      const target = event.target as HTMLElement;

      if (!target) return;

      try {
        // Get dropdown container
        const dropdowns = document.querySelectorAll('.dropdownSelect');
        const dropdown = dropdowns[dropdowns.length - 1] as
          | HTMLElement
          | undefined;

        // Get select input element - check if selector still exists
        if (!this.selector?.originElement?.nativeElement) {
          this.removeFocusTrap();
          return;
        }

        const selectInput =
          this.selector.originElement.nativeElement.querySelector(
            'input'
          ) as HTMLElement | null;
        const selectContainer = this.selector.originElement.nativeElement as
          | HTMLElement
          | undefined;

        // Check if focus is leaving the dropdown area
        if (dropdown && selectInput && selectContainer) {
          const isWithinDropdown =
            dropdown.contains(target) || dropdown === target;
          const isWithinSelectContainer =
            selectContainer.contains(target) || selectContainer === target;

          // If focus is moving outside dropdown and select container, bring it back
          if (!isWithinDropdown && !isWithinSelectContainer) {
            event.preventDefault();
            event.stopPropagation();

            // Return focus to select input after a short delay to allow DOM updates
            setTimeout(() => {
              // Double-check selector still exists and dropdown is still open
              if (
                this.selector?.nzOpen &&
                selectInput &&
                this.selector?.originElement?.nativeElement
              ) {
                try {
                  selectInput.focus();
                } catch (e) {
                  console.warn('Could not focus select input:', e);
                }
              } else {
                // Cleanup if dropdown closed or selector destroyed
                this.removeFocusTrap();
              }
            }, 10);
          }
        }
      } catch (error) {
        // If selector was destroyed, clean up
        this.removeFocusTrap();
      }
    };

    // Add focus trap listener in capture phase to catch focus events early
    document.addEventListener('focusin', this.focusTrapHandler, true);
  }

  /**
   * Removes the focus trap when dropdown closes
   */
  private removeFocusTrap(): void {
    if (this.focusTrapHandler) {
      document.removeEventListener('focusin', this.focusTrapHandler, true);
      this.focusTrapHandler = null;
    }
  }

  /**
   * Ensures the dropdown input is focused when dropdown opens
   */
  private ensureDropdownInputFocused(attempt: number = 0): void {
    if (!this.selector?.nzOpen) {
      return;
    }

    try {
      const selectInput =
        this.selector?.originElement?.nativeElement?.querySelector(
          'input'
        ) as HTMLElement | null;

      if (selectInput) {
        // Focus the input
        selectInput.focus();
      } else {
        // If input not found yet, retry a few times
        if (attempt < 10) {
          setTimeout(() => this.ensureDropdownInputFocused(attempt + 1), 50);
        }
      }
    } catch (error) {
      console.warn('Error focusing dropdown input:', error);
      // Retry if we haven't exceeded attempt limit
      if (attempt < 10) {
        setTimeout(() => this.ensureDropdownInputFocused(attempt + 1), 50);
      }
    }
  }
}
